export default __webpack_public_path__ + "static/day-64f0f93c084c50ef78aca0b34460d182.jpg";